module.exports = "https://pm2019.reeltime.no/public/images/pm_logo_new.cda8863a.png";